resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function TextArea() {
    this.extends = [_Input, TextField];
    this.node = null;
    this.id = null;
    this.declaredClass = null;
    this.deleteIcon = null;
    this.containerDiv = null;
    this.inputContainerDiv = null;

    this.placeholder = "";
    this.placeholderOutside = false;
    this.autoExpand = true;

    this.init = function() {
        this.containerDiv = $("<div class='mogo-ui-textarea'></div>").insertBefore(this.node)[0];
        this.deleteIcon = $("<a class='icon-crosscir textfield' href='#' tabindex='-1'></a>")[0];
        this.inputContainerDiv = $("<div class='input-container'></div>")[0];
        $(this.node).appendTo(this.inputContainerDiv);
        $(this.inputContainerDiv).appendTo(this.containerDiv);
        $(this.deleteIcon).appendTo(this.inputContainerDiv);

        if ($(this.node).attr("placeholder") != null) {
            if (this.placeholder == "") this.placeholder = $(this.node).attr("placeholder");
            $(this.node).attr("placeholder", "");
        }
        if (this.placeholder != "") {
            if (this.placeholderOutside)
                this.placeholderNode = $("<label for='" + this.id + "'>" + this.placeholder + "</label>");
            else
                this.placeholderNode = $("<label class='inner' for='" + this.id + "'>" + this.placeholder + "</label>");
            $(this.placeholderNode).prependTo(this.containerDiv);
        }

        $(this.node).css("display", "block");

        // Connections
        $(this.deleteIcon).on("click", $.proxy(this.onClickDelete, this));
        $(this.placeholderNode).on("click", $.proxy(function(){$(this.node.focus())}, this));
        $(this.node).on("keyup input paste change placeholder", $.proxy(this.onKeyUp, this));
        $(this.node).on("focus", $.proxy(this.onFocus, this));
        $(this.node).on("blur", $.proxy(this.onBlur, this));
        if ($("html.touch").length == 0 && !this.disabled) {
            $(this.containerDiv).on("mouseover", $.proxy(this.onMouseOver, this));
            $(this.containerDiv).on("mouseout", $.proxy(this.onMouseOut, this));
        }

        this._super();
    };

    this.initAllReady = function() {this._super()};

    this.val = function(value) {
        if (value != null) {
            $(this.node).val(value);
            $(this.node).trigger("placeholder");
        } else {
            return $(this.node).val();
        }
    };

    this.onKeyUp = function() {
        this._super();

        if (this.autoExpand) {
            $(this.node).css("height", "auto");
            if (this.node.scrollHeight > this.node.clientHeight) {
                $(this.node).css("height", (this.node.scrollHeight + 2) + "px");
            }
        }
    };
}